/* Comportements globaux du thème Gustave */
(function () {
  'use strict';

  /* --- En-tête : ombre au défilement --- */
  var entete = document.querySelector('[data-entete]');
  if (entete) {
    var majOmbre = function () {
      entete.classList.toggle('entete--scrolled', window.pageYOffset > 8);
    };
    majOmbre();
    window.addEventListener('scroll', majOmbre, { passive: true });

    /* Hauteur réelle de l'en-tête, exposée au CSS.
       L'aperçu du tunnel s'y accroche sur mobile. */
    var majHauteur = function () {
      document.documentElement.style.setProperty(
        '--entete-h', Math.round(entete.getBoundingClientRect().height) + 'px'
      );
    };
    majHauteur();
    window.addEventListener('resize', majHauteur, { passive: true });
  }

  /* --- Menu mobile --- */
  var burger = document.querySelector('[data-burger]');
  if (burger && entete) {
    burger.addEventListener('click', function () {
      var ouvert = entete.getAttribute('data-menu') === 'open';
      entete.setAttribute('data-menu', ouvert ? 'closed' : 'open');
      burger.setAttribute('aria-expanded', String(!ouvert));
      burger.setAttribute('aria-label', ouvert ? 'Ouvrir le menu' : 'Fermer le menu');
    });
    entete.querySelectorAll('.entete__nav a').forEach(function (a) {
      a.addEventListener('click', function () {
        entete.setAttribute('data-menu', 'closed');
        burger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* --- Ancre active selon la section visible --- */
  var ancres = Array.prototype.slice.call(document.querySelectorAll('[data-ancre]'));
  if (ancres.length && 'IntersectionObserver' in window) {
    var cibles = ancres
      .map(function (a) {
        var id = a.getAttribute('href').split('#')[1];
        return id ? document.getElementById(id) : null;
      })
      .filter(Boolean);

    if (cibles.length) {
      var obsAncres = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (en) {
          if (!en.isIntersecting) return;
          ancres.forEach(function (a) {
            a.setAttribute('aria-current', a.getAttribute('href').indexOf('#' + en.target.id) !== -1 ? 'true' : 'false');
          });
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      cibles.forEach(function (c) { obsAncres.observe(c); });
    }
  }

  /* --- Apparition douce --- */
  var aReveler = document.querySelectorAll('.reveal');
  if (aReveler.length) {
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var obsReveal = new IntersectionObserver(function (entrees, o) {
        entrees.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); o.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
      aReveler.forEach(function (el) { obsReveal.observe(el); });
    } else {
      aReveler.forEach(function (el) { el.classList.add('is-in'); });
    }
  }

  /* --- Compte à rebours jusqu'à minuit --- */
  var compte = document.querySelector('[data-compte]');
  if (compte) {
    var h = compte.querySelector('[data-compte-h]');
    var m = compte.querySelector('[data-compte-m]');
    var s = compte.querySelector('[data-compte-s]');

    var deuxChiffres = function (n) { return n < 10 ? '0' + n : String(n); };

    var majCompte = function () {
      var maintenant = new Date();
      var minuit = new Date(maintenant);
      minuit.setHours(24, 0, 0, 0);
      var reste = Math.max(0, Math.floor((minuit - maintenant) / 1000));
      h.textContent = deuxChiffres(Math.floor(reste / 3600));
      m.textContent = deuxChiffres(Math.floor((reste % 3600) / 60));
      s.textContent = deuxChiffres(reste % 60);
    };

    majCompte();
    compte.hidden = false;
    setInterval(majCompte, 1000);
  }

  /* --- Galerie : révéler le reste des portraits --- */
  var bouton = document.querySelector('[data-galerie-plus]');
  if (bouton) {
    var caches = Array.prototype.slice.call(document.querySelectorAll('[data-galerie-cache]'));
    var libelle = bouton.querySelector('[data-galerie-libelle]');

    if (!caches.length) {
      bouton.hidden = true;
    } else {
      bouton.addEventListener('click', function () {
        var ouvert = bouton.getAttribute('aria-expanded') === 'true';
        caches.forEach(function (el) {
          el.hidden = ouvert;
          el.classList.toggle('galerie__item--cache', ouvert);
          if (!ouvert) requestAnimationFrame(function () { el.classList.add('is-in'); });
        });
        bouton.setAttribute('aria-expanded', String(!ouvert));
        libelle.textContent = ouvert ? 'Voir plus de portraits' : 'Voir moins';
        bouton.classList.toggle('btn--replier', !ouvert);
      });
      bouton.setAttribute('aria-expanded', 'false');
    }
  }

  /* --- FAQ : une seule réponse ouverte à la fois --- */
  var faq = document.querySelector('[data-faq]');
  if (faq) {
    var details = Array.prototype.slice.call(faq.querySelectorAll('details'));
    details.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        details.forEach(function (autre) { if (autre !== d) autre.open = false; });
      });
    });
  }
})();
